import { api } from 'shared';
import { z } from 'zod';

export const DegustationLeadFormResponseSchema = z.object({
    data: z.object({
        image: z.object({
            url: z.string(),
        }).optional().nullable(),
        commercialOfferFile: z.object({
            url: z.string(),
        }).optional().nullable(),
    }),
});
export const fetchDegustationLeadForm = async () => (
    api.get<z.infer<typeof DegustationLeadFormResponseSchema>>(
        '/degustation-lead-form',
        {
            populate: {
                image: {
                    fields: 'url',
                },
                commercialOfferFile: {
                    fields: 'url',
                },
            },
        },
        DegustationLeadFormResponseSchema,
    )
);
